import { render } from "./ReleaseNotesComp.vue?vue&type=template&id=b8141be2&scoped=true&ts=true"
import script from "./ReleaseNotesComp.vue?vue&type=script&lang=ts"
export * from "./ReleaseNotesComp.vue?vue&type=script&lang=ts"

import "./ReleaseNotesComp.vue?vue&type=style&index=0&id=b8141be2&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8141be2"]])

export default __exports__